export const CUSTOM_ELEVATIONS = {
  default:
    "rgba(255, 255, 255, 0.05) 0px 5rem 14rem 0px, rgba(0, 0, 0, 0.2) 0px 0.8rem 2.3rem, rgba(0, 0, 0, 0.15) 0px 0.2rem 0.3rem",
  filter:
    "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.2) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
  menu: "0px 9px 16px rgba(159, 162, 191, .18), 0px 2px 2px rgba(159, 162, 191, 0.32)",
};
